export default __webpack_public_path__ + "static/media/cyber-girl-mask.2ccdae8e.jpg";